<div class="mr-t--md mr-b--md">
    <a class="btn btn-link btn-icon btn-icon--left btn-back"
       *ngIf="!isHome"
       [routerLink]="['/home']">
        {{ 'back' | translate }}
    </a>
    <app-breadcrumb class="hidden"
            [firstNode]="{label: 'Platform Registration Counts', 'url': '/home'}">
    </app-breadcrumb>

    <div class="box">
        <div class="card card--b2c--box pb-1">
            <div class="card--b2c--box__header">
                <div class="card--b2c--box__header--info">
                    <div *ngIf="!isClinicView" class="card--b2c--box__header__title">
                        {{ 'Platform Registration Counts' | translate }}
                    </div>
                </div>
                <div class="text-xs-right">
                    <span class="card--b2c--box__header__action">
                        <button *ngIf="isHome"
                                type="button" class="btn btn-block pl-3"
                                [routerLink]="['/b2c-patients/platform-registration-counts']">
                            {{ 'View All' | translate }}
                            <i class="fal fa-light fa-arrow-right"></i>
                        </button>
                    </span>
                </div>
            </div>
        </div>

        <div class="b2c-table--grid platform-registration-counts" *ngIf="items.length">
            <div class="b2c-table--grid__body platform_registration_counts__body">
                <div class="row">
                    <!--table headers-->
                    <div class="col-xs-11 col-lg-10 platform_registration_counts__column">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}"
                                 (click)="sortPlatformRegistrationCount(column[0]);"
                                 title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && (sortedColumn === column[0]
                                                || (sortedColumn === 'created_at_sort' && column[0] === 'created_at')),
                                                'asc': order === 'asc', 'desc': order === 'desc'}">
                                    {{ column[1] | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--table cells-->
                <div *ngFor="let platform of items
                        | orderBy : orderField: sortedColumn
                        | slice : ((currentPage-1)*itemsPerPage):(currentPage*itemsPerPage)"
                     class="row">
                    <div class="col-xs-11 col-lg-10">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}">
                                <span *ngIf="column[0] !== 'active'" class="col col--{{column[0]}}">
                                    <i *ngIf="column[0] === 'code'" class="fal fa-copy"
                                       (click)="clipboard(platform[column[0]], pop)"
                                       tooltip="{{'Copied : ' | translate}} {{ platform[column[0]] }}" container="body" placement="top" triggers="click" #pop="bs-tooltip">
                                    </i>
                                    <span [ngSwitch]="column[0]">
                                        <span> {{ platform[column[0]] }} </span>
                                    </span>
                                </span>

                                <div class="" *ngIf="column[0] === 'active'">
                                    <mat-slide-toggle [(ngModel)]="platform['active']" (change)="activate(platform)"
                                                      [class.disabled]="params['action'] === 'read'">
                                    </mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--pagination-->
    <pagination-component *ngIf="!paginationHidden && !isHome" [(page)]="currentPage"
                          [total]="items" [perPage]="itemsPerPage"
                          [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)"
                          #pagination></pagination-component>
</div>
<dialog-component #dialog></dialog-component>
